import React from 'react';


export default ({ type }) => {
    let message = 'This Estimate Link Has Expired';
    if (type === 'storage') {
        message = 'This Storage Link Has Expired';
    }
    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 blue-background-color" >
            <div className="row">
                <div className="col d-flex justify-content-center align-items-center text-white">
                    <img src={process.env.PUBLIC_URL + "/Images/SomethingWentWrong.gif"} width='150' alt="Link Expired"/>
                    <div>
                        <h3><b>{message}</b></h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

